import React from 'react';
import { ProcessHype, ProcessSteps, SEO } from '../../components';
import { graphql } from 'gatsby';
import { withBuilderPageOverride } from '../../hooks/useBuilderPageOverride';
import './process.css';

function ProcessPage() {
  return (
    <main id='process-page'>
      <ProcessHype />
      <ProcessSteps />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.site.siteMetadata;
  return (
    <SEO
      location={location}
      origin={query.siteUrl}
      title={`How Laser Hair Removal Works | ${query.vertical}`}
      description='Click here to see how Milan laser hair removal works, what you can expect during your visit, and some pre and post treatment considerations.'
    />
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        siteUrl
        umbrella
        vertical
        service
        title
      }
    }
  }
`;

export default withBuilderPageOverride(ProcessPage, '/process');
